import { render, staticRenderFns } from "./analysisTable.vue?vue&type=template&id=031a000b&scoped=true&"
import script from "./analysisTable.vue?vue&type=script&lang=js&"
export * from "./analysisTable.vue?vue&type=script&lang=js&"
import style0 from "./analysisTable.vue?vue&type=style&index=0&id=031a000b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a000b",
  null
  
)

export default component.exports